angular.module('bmsApp.merrymaids.schedule').factory('MMScheduleSvc', MMScheduleSvc);

MMScheduleSvc.$inject = [
	'$modal',
	'$state',
];

function MMScheduleSvc(
	$modal,
	$state
) {
	function warningsModal(warnings, date, showFixOptions) {
		let modalInstance = $modal.open({
			animation: true,
			templateUrl: 'ng/merrymaids/schedule/templates/MMScheduleWarningsModal.html',
			controller: 'MMScheduleWarningsModalCtrl as Ctrl',
			size: 'lg',
			backdrop: 'static', // disable click-outside closing modal
			resolve: {
				warnings: function () {
					return warnings;
				},
				showFixOptions: function () {
					return showFixOptions;
				},
			}
		});
		modalInstance.result.catch((result) => {
			if (result === 'fix') {
				$state.go('main.merrymaids.schedule.daily', {date: date.format()});
			}
		});
	}

	function worksheetsModal(date, routes, unroutedJobParts) {
		let modalInstance = $modal.open({
			animation: true,
			templateUrl: 'ng/merrymaids/schedule/templates/MMScheduleRouteJobSelectionModal.html',
			controller: 'MMScheduleRouteJobSelectionModalCtrl',
			size: 'lg',
			backdrop: 'static', // disable click-outside closing modal
			resolve: {
				date: function () {
					return angular.copy(date);
				},
				routes: function () {
					return angular.copy(routes)
				},
				unroutedJobParts: function () {
					return angular.copy(unroutedJobParts);
				}
			}
		});
	}

	function preInvoiceModal(date) {
		let modalInstance = $modal.open({
			animation: true,
			templateUrl: 'ng/merrymaids/schedule/templates/MMSchedulePreInvoiceModal.html',
			controller: 'MMSchedulePreInvoiceModalCtrl as Ctrl',
			size: 'lg',
			backdrop: 'static', // disable click-outside closing modal
			resolve: {
				date: function () {
					return angular.copy(date);
				},
			}
		});
	}

	return {
		warningsModal: warningsModal,
		worksheetsModal: worksheetsModal,
		preInvoiceModal: preInvoiceModal,
	}
}